<template>
    <el-select v-model="model" filterable @change="handleChange" clearable remote reserve-keyword :remote-method="getData" :placeholder="placeholder">
        <el-option label="不限" value="" v-if="hasAll"></el-option>
        <template v-for="(item, i) in list">
            <el-option v-if="typeof(model) == 'string'" :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>
            <el-option  v-else-if="typeof(model) == 'number'" :key="'ds-' + i" :label="item[label]" :value="parseInt(item[key])"></el-option>
            <el-option  v-else :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>
        </template>
<!--        <el-option v-for="(item, i) in list" :key="'ds-' + i" :label="item[label]" :value="item[key]"></el-option>-->
    </el-select>
</template>

<script>
    // import axios from '@/util/api'

    export default {
        props: {
            value: {},
            param: {},
            placeholder: {},
            hasAll: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                model: '',
                list: [],
                key: '',
                label: '',
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.model = val
                    // this.handleChange()
                },
                immediate: true
            },
            model() {
                this.$emit('input', this.model)
            }
        },
        created() {
            if (!this.param.param) {
                return ''
            }

            const select = this.param.param
            this.key = select.key || 'key'
            this.label = select.value || 'value'
            this.getData()
        },
        methods: {
            getData(keyword) {
                    this.$api.post(this.param.param.api, {
                        model: {
                            keyword
                        },
                        page: {
                            current: 1,
                            size: 20,
                        }
                    }).then(res => {
                        this.list = res.records;
                    })
            },
            handleChange() {
                this.$emit('change', this.model);
            }
        }
    }
</script>